import { Fragment, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
// component
import PageBreadcrumb from "elements/System/PageBreadcrumb";
import NotificationPreference from "elements/System/NotificationPreference";
import { common } from "includes";

export default function NotificationPreferenceList() {
  // const
  const navigate = useNavigate();
  const authData = common.getAuth();

  // state
  const [permission] = useState(common.getUserPermission());
  // effect
  useEffect(() => {
    if (!permission?.includes("nor")) {
      common.redirect("app/home");
    }
  }, []);

  return (
    <Fragment>
      <PageBreadcrumb
        breadCrumbItems={[
          {
            label: "Notification Preference List",
            path: "/notification-preference/list",
            active: true,
          },
        ]}
        title={"Edit Your Preferences"}
      />
      <NotificationPreference userId={authData._id} />
    </Fragment>
  );
}
